import { includes, isLineItemCancellable } from "./chunk-3AM4GNWY.js";
import { getServiceStateName, getServices } from "./chunk-JZDFGTTT.js";
import { ORDER_STATES, PAYMENT_STATES, getStateNameById } from "./chunk-7FPOUA55.js";

// src/order.ts
var getOrderStateName = (env, orderState) => {
  const stateId = orderState.id;
  return getStateNameById(env, stateId);
};
var isOrderCancellable = (env, order) => {
  const {
    lineItems,
    state: orderState
  } = order;
  const orderStateName = getOrderStateName(env, orderState);
  const ALLOWED_ORDER_STATES = [ORDER_STATES.OPEN, ORDER_STATES.PROCESSING, ORDER_STATES.COMPLETED];
  if (!includes(ALLOWED_ORDER_STATES, orderStateName)) {
    return false;
  }
  const hasUnCancellableLineItems = lineItems.some(lineItem => !isLineItemCancellable(lineItem, order, env));
  return !hasUnCancellableLineItems;
};
var isPaymentAgreed = order => order.paymentState === PAYMENT_STATES.BALANCE_DUE;
var hasDeliveredArtWorkService = (order, env) => {
  const services = getServices(order);
  const serviceStateNames = [];
  if (services.length > 0) {
    services.forEach(service => {
      const stateName = getServiceStateName(service, env);
      if (stateName) {
        serviceStateNames.push(stateName);
      }
    });
  }
  if (serviceStateNames.length > 0) {
    return !includes(serviceStateNames, "Cancelled") && (includes(serviceStateNames, "ServiceInProgress") || includes(serviceStateNames, "EditInProgress") || includes(serviceStateNames, "ServiceDelivered"));
  }
  return false;
};
export { getOrderStateName, isOrderCancellable, isPaymentAgreed, hasDeliveredArtWorkService };